export default __webpack_public_path__ + "static/media/triangles01-66.65b37359.svg";